export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 2a6 6 0 100 12A6 6 0 008 2zM0 8a8 8 0 1116 0A8 8 0 010 8zm9 4a1 1 0 11-2 0 1 1 0 012 0zM7.25 5.339A1 1 0 007 8v1a1 1 0 002 0v-.17a3.001 3.001 0 10-3.25-4.815 1 1 0 001.5 1.324z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};